<template>
  <div class="title">
    <div class="title">
      <i class="goback el-icon-arrow-left" @click="goback"></i>新建服务通知
    </div>
    <div class="content">
      <div class="set_flexwrap">
        <div class="flex_wrap">
          <el-form ref="form" :model="form" label-width="80px">
            <el-form-item label="接收人群">预计1人</el-form-item>
            <el-form-item label="消息名称">
              <el-input type="text" maxlength="20" show-word-limit placeholder="请填写消息名称"></el-input>
            </el-form-item>
            <el-form-item label="点击跳转">
              <el-select v-model="form.value" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="模板类型">完成目标通知</el-form-item>
            <el-form-item label="活动名称">
              <el-input type="text" maxlength="7" show-word-limit placeholder="请填写活动名称"></el-input>
            </el-form-item>
            <el-form-item label="温馨提示">
              <el-input type="textarea" maxlength="7" show-word-limit placeholder="请填写温馨提示"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="onSubmit">取 消</el-button>
              <el-button type="primary" @click="onSubmit">立即发送</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="preview_wrap notification_wrap">
          <div class="headerImg"></div>
          <div class="info-block">
            <div class="header">
              <div>
                <img
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAFpOLgnAAAAAXNSR0IArs4c6QAABZNJREFUaAXtmYdy4yAQhnF67z2ZSd7/qdJ77z2Xj7sfrxCyJI+T+GayMzYIFrawDamxu7v74Qqgp2DcD+cmX19fA34fvc3NTTc1NeWYeH9/d/f3925jY8P5SRBGR0ddf3+/R+jt7WXINdpmqHBljtOnpydPy0/AHZwdHR25wcFBP+E5fHh4cHD18vLi9vf33fPzs/MrxsfHPRasAwMDA02ZRkZGHD9BjrgmCtkVQqoNqrOTcH98fByG0LGFDAscCj8AxOHhYbe2tuYuLy/9mP4CJZA5qI+Pv3ZycXHhVXJ1deVQJGpBRaurq3+1oN3v7u78ZrAnuLm58V0WCdpSRO1FGSWIdKu20oLHx8ewR9CYRhASw7FgzyZQeHt78zgYEgCSEJMUbm9vHeeQgqGhoTDstcR5YJHYsvQ/NjbmkdhIsL6+3jRjTlRsgSD3pL+yskLjIciAiUxOTmrcTU9P+x8DyCXZAksBs6TTJSdtuazNkl1ctR80W3VBER5Oaq3I4lUiIke2C+M+kdNanp2vRAT7IVJgrRgeP0IyLRIw3gpy3gcyCxXTr6+v3fn5uVtYWPD77OzshP1sPwwmOhki4kjpAGJ9fRmU4MVIsri46DPdZ4Jr5pOeHu9Odl1SXfgfkoCovJNgMDdEGEG1rCMWKYonieRWVxwgFRDsaEn0gqwu/o1yDlgUiD2f4luQShmzfZ4V71CzheCMh4eHdrxj/aWlpWZc5OGrIKuLL6IS1PVF+/ttv0WS/4cI5k5CLYKOSSLvThFKOqNFVI4oCuPgEkpaQSkRbR57t92UQElZWgSlROzC5eVlH/xOTk7c/Py8n6oS7nNnQnKSiiwB+kRnfsQz9S2OvRrZ8ZbOyKLT01MfKG29bDegX1tdbIw6bCRVecZVgFzBfUKZUmdls2nMRDgTNlbBgO6JygTNg4ODeE3yWXgTExNuZmYmgxOIWH1KNWq1gnzRaDR8YkKNKSAX8UNiJAdyB8+gcrxaxgCq3Lm5OV/d0vITkKaVfmkt00ESIdOiOjyY1gJpFcsihCgLah58JCebxhpISoIPoBb5gjaidkcauLa1O/MQ4TZMLUZrIUnEIlTtIyFMwIC9SLA+qa69vT3PGa0F6iuBTFfPqFBjslLNeUnwcOsXCttqYx1rsVoKvRToeu0lQVQFwhRyu2OYMdAyrLS7ebyuYwcfb2yff4lYbZT2v+XgS7noAMK3nHsH+CzdousEIYARx+tCVwlCQiLY0daFrhJEBYoidx1hkkmxzgbgUtVS+2EWVK5xfVF1P0qGdlNaRwTRO3c02apULxPIvr8ow43nSwXBXvlRYbS64cQb86zKXHNU6OxF+S+gxLTlj8brtqU+AmFKJbRNWxRRGOc0LKBhKaJVa9fQpwSzpVk8n3ouPRFKMZkOlSca1BuqmBh+wvcsAbgIIJDp2BoxpRjo1IVCQWCCt/ho2RKuQwDBbAQiECCYXp2yF3Qs6IsYa7mr8WaAaFYGSUG49MXaRtPS9tbWlr+wcFKYQVzyi2j8tUWns729LZTCFuVxT7R3RSIawslC7OKkIBZBfRi2dw38BcZSpqE1fGKxJ1LV2TEtfZ5BEOjopoeS2YfvPPakKgvCIvwFUJ9naVnMd6JFObytB2TWeo5NUfQqC4JmFX5hHhvmWZc8bWhbLuVWa2LKvnVOKQJfmp2d9VudnZ35i7qeMXntY2lVFoTPebqQQ5zszduCFCMigDm0Y1qciG6x8lU9F5lyZUF4r2KdnXKizNnxKZkjwikc6xsnYwrJ9AWciL5/cuIoS89E0ZQwGUFYoIXaVC0akVYYw+FiYL0lUlRzYS4pEG3aONvHyRbz4rQRGsjcEIlE1n5TxLppzKaEjCDdxGRdXkprrbob/hT+ryA/pfkiur8nUqSZnxr/A8+WhHw0xUIBAAAAAElFTkSuQmCC"
                  style="width: 26px; height: 26px; margin-right: 7px;"
                >
                泉州市图彩数码科技有限公司
              </div>
              <div>
                <i class="iconfont icon-more"></i>
              </div>
            </div>
            <div class="center-i">
              <div class="content-title">完成目标通知</div>
              <div>活动名称</div>
              <div class="theme-text"></div>
              <div class="split-line"></div>
              <div style="display: flex;">
                <div style="width: 70px;">温馨提示</div>
                <div class="content-text"></div>
              </div>
            </div>
            <div class="column-block bb">进入小程序查看</div>
            <div class="column-block">拒绝通知</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "notificationAdd",
  data() {
    return {
      form: {},
      options: []
    };
  },
  methods: {
    onSubmit() {
      // console.log("submit!");
    },
    goback() {
      this.$router.go(-1);
    }
  }
};
</script>